import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import { selectIsMyTimesheetEnabled } from 'services/organizationConfig/selectors';

export interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    myTimesheetsExists: boolean;
}

type Props = OwnProps & ConnectedProps;

/**
 * A component to wrap around content only visible to organisations that have a my timesheets feature enabled.
 */
export class MyTimesheetsExistsGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, myTimesheetsExists } = this.props;

        if (!myTimesheetsExists) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    myTimesheetsExists: selectIsMyTimesheetEnabled
});

export default connect(mapStateToProps)(MyTimesheetsExistsGate);
